export default __webpack_public_path__ + "static/media/upload-files.e28983ea.svg";